import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

export const ToggleOrdersFilter: Handler = props => {
    props.dispatch({
        type: "Custom/RMA/ToggleFiltersOpen",
    });
};

export const chain = [ToggleOrdersFilter];

const RMAtoggleFiltersOpen = createHandlerChainRunnerOptionalParameter(chain, {}, "RMAtoggleFiltersOpen");
export default RMAtoggleFiltersOpen;
